import React from 'react';
import { IconProps } from '.';

const SvgNumSixFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M12.104 16.575c2.13.006 3.574-1.367 3.568-3.281.006-1.778-1.257-3.047-2.956-3.047-1.041 0-1.973.488-2.409 1.328h-.09c.012-1.856.683-3.008 1.965-3.008.762 0 1.302.41 1.459 1.068h1.927c-.189-1.55-1.491-2.748-3.386-2.748-2.356 0-3.873 1.882-3.88 5.065-.006 3.45 1.856 4.616 3.802 4.623Zm-1.692-3.23a1.698 1.698 0 0 1 1.705-1.68c.957.007 1.654.737 1.654 1.68 0 .951-.71 1.687-1.68 1.68-.963.007-1.666-.755-1.68-1.68Z'
      />
    </svg>
  );
};

export default SvgNumSixFill;
